import React from 'react';
import { Modal } from '@isyc-react/design/bootstrap';
import { useTranslation } from 'react-i18next';
import { nsform } from "../../../i18n/namespaces";
import '@isyc-react/design/main';
export const LocatorModal = props => {
  const {
    modal,
    setModal,
    blur,
    children
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  return /*#__PURE__*/React.createElement(Modal, {
    centered: true,
    scrollable: true,
    show: modal,
    onHide: () => {
      setModal(false);
      blur();
    },
    size: 'xl',
    className: "input-locator-modal-container"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "bg-primary",
    closeButton: true,
    closeVariant: "white"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    as: 'h5'
  }, t('input.locator.modal.header.title'))), /*#__PURE__*/React.createElement(Modal.Body, null, children));
};